import { useState, createContext, useContext } from 'react';

export const AppVersionUpdaterContext = createContext();
export const AppVersionUpdaterProvider = ({ children }) => {
  const [newVersionData, setNewVersionData] = useState();

  const updateAppVersion = (incomingVersionData) => {
    setNewVersionData(incomingVersionData);
  };

  return (
    <AppVersionUpdaterContext.Provider
      value={{
        newVersionData,
        updateAppVersion,
      }}
    >
      {children}
    </AppVersionUpdaterContext.Provider>
  );
};

export const useAppVersionUpdaterProvider = () =>
  useContext(AppVersionUpdaterContext);
